import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
    templateUrl: 'edit-modal-footer.component.html',
    selector: 'modal-footer',
    standalone: false
})
export class EditModalFooterComponent {
  @Input() editForm: UntypedFormGroup;
  @Input() processing: boolean;

  constructor(private location: Location) {}

  public cancel() {
    this.location.back();
  }
}
